import { Dispatch, useEffect, useReducer, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import API from 'api/API';
import { SetDraftResponse } from 'api/Responses/SetResponses';
import { draftActions, SetAction } from 'reducers/DraftReducer/draftActions';
import setReducer, { initialSet } from 'reducers/DraftReducer/draftReducer';

interface UseDraft {
  loading: boolean;
  set: SetDraftResponse;
  dispatchSet: Dispatch<SetAction>;
}

export interface DispatchDraft {
  set: SetDraftResponse;
  dispatchSet: Dispatch<SetAction>;
}

export const useSet = (code: string, isUsingV2: boolean, goBack: boolean): UseDraft => {
  const [set, dispatchSet] = useReducer(setReducer, initialSet);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    (async (): Promise<void> => {
      try {
        if (isUsingV2) {
          const draftV2 = await API.set.getV2(code);
          dispatchSet(draftActions.init(draftV2));
        } else {
          const draft = await API.set.get(code);

          dispatchSet(draftActions.init({ ...draft, is_view_only: false }));
        }
      } catch (error) {
        API.errorHandler(error);
        goBack && navigate(-1);
      }
      setLoading(false);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [code]);

  return { loading, set, dispatchSet };
};
